module.exports = __webpack_public_path__ + "assets/img/jiao.faf94181.png";